import React from 'react'
import PropTypes from 'prop-types'
import { Single } from '~/components/common/AsyncSelect'

const SingleAsyncSelect = ({
  field,
  form,
  forwardValues,
  revertValues,
  options,
  disabled,
  ...props
}) => (
  <Single
    name={field.name}
    {...field}
    values={forwardValues(field.value)}
    onChange={(v) => form.setFieldValue(field.name, revertValues(v))}
    options={options}
    disabled={disabled || !!form.values.__readOnly}
    {...props}
  />
)

SingleAsyncSelect.defaultProps = {
  forwardValues: (v) => v,
  revertValues: (v) => v,
  options: [],
  disabled: false,
}

SingleAsyncSelect.propTypes = {
  forwardValues: PropTypes.func,
  revertValues: PropTypes.func,
  form: PropTypes.shape().isRequired,
  field: PropTypes.shape().isRequired,
  options: PropTypes.shape(),
  disabled: PropTypes.bool,
}

export default SingleAsyncSelect
